import React, { useEffect, useState } from "react";

import { Provider } from "./referral-ots-client-enrolment-context";

import { userProfileData } from "../../Common/profileInfo";
import { InitiateEnrollment } from "../../queries/InitiateEnrollment";
import { clientConfig } from "../../awsClientConfig";
import Loading from "../../Common/Loading";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router";
import ReferralOtsEntryForm from "./referral-ots-entry-form";
import ProfileInformation from "./profile-information";
import ServiceAgreementForm from "./service-agreement-form";
import SignatureForm from "./signature-form";
import GovernmentIdUploadForm from "./goverment-id-upload-form";
import SignServiceAgreementForm from "./sign-service-agreement-form";
import BillingInformationForm from "./billing-information-form";
import EnrollmentCompletedForm from "./enrollment-completed-form";
import PaymentDetailsForm from "./payment-details-form";
import ProtectionPlanEligibility from "./protection-plan-eligibility";
import Footer from "../footer";



const ReferalOtsClientEnrolmentForm = () => {
  const [enrollmentId, setEnrollmentId] = useState("");
  const [currentStep, setCurrentStep] = useState(10);
  const [nextFormId, setNextFormId] = useState("");
  const [s3key, setS3Key] = useState("");
  const [s3Bucket, setS3Bucket] = useState("");
  const [billingAddress, setBillingAddress] = useState();
  const [priceDetail, setPriceDetail] = useState();
  const navigate = useNavigate();
  const [enrolmentAction, setEnrolmentAction] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const client = new clientConfig();
      await Auth.currentAuthenticatedUser({ bypassCache: true });
      const profileId = await userProfileData();
      const variables = {
        profileId: profileId,
        type: "ReferralProtectionPlan",
      };
      client
        .mutate({ mutation: InitiateEnrollment, variables: variables })
        .then((res: any) => {
          if (res.data.InitiateEnrollment.Id) {
            setEnrollmentId(res.data.InitiateEnrollment.Id);
            setNextFormId(res.data.InitiateEnrollment.NextForm?.Id);
            setS3Bucket(res.data.InitiateEnrollment.NextForm?.S3Bucket);
            setS3Key(res.data.InitiateEnrollment.NextForm?.S3Key);
            setPriceDetail(res.data.InitiateEnrollment?.ProtectionPlan);
            setEnrolmentAction(res.data.InitiateEnrollment?.NextEnrollmentAction);
            setCurrentStep(0);
            /*
            NextEnrollmentAction(
              res.data.InitiateEnrollment?.NextEnrollmentAction
            );*/
          }
        })
        .catch((error: any) => {
          //navigate("/dashboard");
          setCurrentStep(0);
        });
    };

    fetchData();
  },[]);

  const onUpgradeClickHandler = () => {
    console.log(enrolmentAction);
    enrolmentAction?NextEnrollmentAction(enrolmentAction):next();
  }

  const renderStep = (step: number) => {
    switch (step) {
      case 0:
        return <ReferralOtsEntryForm onUpgrade={onUpgradeClickHandler}/>;
      case 1:
        return <ProfileInformation />;
      case 2:
        return <ServiceAgreementForm />;
      case 3:
        return <SignatureForm />;
      case 4:
        return <GovernmentIdUploadForm />;
      case 5:
        return <SignServiceAgreementForm />;
      case 6:
        return <EnrollmentCompletedForm />;
      case 10:
        return <Loading />;
      default:
        return null;
    }
  };

  const NextEnrollmentAction = (nextAction: string) => {
    if (nextAction === "CompleteInformation") {
      setCurrentStep(1);
    }
    if (nextAction === "CompleteServiceAgreement") {
      setCurrentStep(2);
    }
    if (nextAction === "UploadIdentification") {
      setCurrentStep(4);
    }
    if (nextAction === "CompleteForm8821") {
      setCurrentStep(5);
    }
    if (nextAction === "CompletePayment") {
      setCurrentStep(6);
    }
    if (!nextAction){
      navigate("/dashboard");
    }
  };

  const next = () => {
    if (currentStep === 8) {
      setCurrentStep(0);
      return;
    }
    setCurrentStep(currentStep + 1);
  };

  const previous = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <Provider
      value={{
        next,
        previous,
        enrollmentId,
        setEnrollmentId,
        nextFormId,
        setNextFormId,
        s3key,
        setS3Key,
        s3Bucket,
        setS3Bucket,
        billingAddress,
        setBillingAddress,
        priceDetail,
        setCurrentStep
      }}
    >
      <>
      <div className="page-container">
      <main>{renderStep(currentStep)}</main>
      </div>
      <div className="my-2">
      <Footer/>
      </div>
      </>
    </Provider>
  );
};
export default ReferalOtsClientEnrolmentForm;
